'use client';

import { ReactNode } from 'react';
import { ConfigProvider } from '@/ui';
import { getUiConfig } from '../config/getUiConfig';
import { GlobalStyles } from '../styles/GlobalStyles';
import { CommonDataProvider } from '../common-data/useCommonData';
import { ICommonData } from '../common-data/ICommonData';

interface IProvidersProps {
	commonData: ICommonData;
	children: ReactNode;
}

export function Providers({ commonData, children }: IProvidersProps) {
	return (
		<CommonDataProvider value={commonData}>
			<ConfigProvider config={getUiConfig()}>
				<GlobalStyles />
				{children}
			</ConfigProvider>
		</CommonDataProvider>
	);
}
